import $ from "jquery";

$(".mouse_scroll").click(function() {
    $('html, body').animate({
        scrollTop: $("#location_nacelles").offset().top - 65
    }, 500);
});

$(".btn-discover").click(function() {
    $('html, body').animate({
        scrollTop: $("#location_nacelles").offset().top - 65
    }, 500);
});